import React from 'react';

import Show from 'components/Show';
import Editor from 'components/Editor';
import Icon from 'components/Misc/Icon';

import { useExamReviewStore } from 'store/exam/useExamReviewStore';

const Option = ({ option }) => {
	// Use exam's student store
	const slug = useExamReviewStore(state => state.exam.slug);

	return (
		<div key={option.id} className="flex gap-4 items-center">
			{/* Show if correct answer and should be selected */}
			<Show if={option.answer && option.correct}>
				<Icon
					icon="done"
					className="flex-shrink-0 block w-7 h-7 leading-7 text-center text-emerald-500 border border-emerald-500 rounded-lg"
				/>
			</Show>

			{/* Show if correct answer and should not be selected*/}
			<Show if={!option.answer && option.correct}>
				<Icon
					icon="close"
					className="flex-shrink-0 block w-7 h-7 leading-7 text-center text-neutral-200 border border-neutral-200 dark:text-neutral-600 dark:border-neutral-600 rounded-lg"
				/>
			</Show>

			{/* Show if incorrect answer and should not be selected */}
			<Show if={option.answer && !option.correct}>
				<Icon
					icon="close"
					className="flex-shrink-0 block w-7 h-7 leading-7 text-center text-red-500 border border-red-500 rounded-lg"
				/>
			</Show>

			{/* Show if incorrect answer and should be selected */}
			<Show if={!option.answer && !option.correct}>
				<Icon
					icon="check"
					className="flex-shrink-0 block w-7 h-7 leading-7 text-center text-neutral-200 border border-neutral-200 dark:text-neutral-600 dark:border-neutral-600 rounded-lg"
				/>
			</Show>

			{/* Option's content */}
			<Editor
				readOnly
				path="exams"
				folder={slug}
				value={option?.content}
			/>
		</div>
	);
};

export default Option;